// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Emac_Zone = require("../emac/Emac_Zone.bs.js");
var Type_Club = require("../club/Type_Club.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Emac_Teaser = require("../emac/Emac_Teaser.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Util_Logger = require("../util/Util_Logger.bs.js");
var Emac_V4_Teaser = require("../emac/v4/Emac_V4_Teaser.bs.js");
var Binding_Constant = require("../binding/Binding_Constant.bs.js");
var Particle_Screen_Ds = require("../design-system/particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Constants = require("../design-system/particle/Particle_Spacer_Constants.bs.js");

function canBeDisplayed(zone) {
  if (typeof zone !== "object") {
    return true;
  }
  var variant = zone.NAME;
  if (variant === "Slider") {
    return zone.VAL.data.length !== 0;
  } else if (variant === "PaginatedGrid") {
    return zone.VAL[0].data.length !== 0;
  } else {
    return true;
  }
}

function getFirstTeaser(toDsTeaser, data) {
  return Belt_Option.map(Belt_Array.get(data, 0), toDsTeaser);
}

function getFirstTeaserV4(toDsTeaser, data) {
  return Belt_Option.map(Belt_Array.get(data, 0), toDsTeaser);
}

function makeLink(emacLink) {
  return Belt_Option.map(emacLink, (function (param) {
                return {
                        url: Caml_option.nullable_to_opt(param.url),
                        title: Caml_option.nullable_to_opt(param.title)
                      };
              }));
}

function makeLinkFromV4(emacV4Link) {
  return makeLink(Belt_Option.map(emacV4Link, (function (param) {
                    return {
                            title: param.title,
                            url: param.url,
                            label: param.label
                          };
                  })));
}

function make(toDsTeaser, zone) {
  var itemTemplate = Curry._1(Binding_Constant.Zone.Item_Template.decode, zone.displayOptions.itemTemplate);
  var match = zone.displayOptions.showItemTitle;
  var itemTitle = match ? (
      itemTemplate !== 7 ? /* Normal */0 : /* SubtitleAsTitle */1
    ) : (
      itemTemplate !== 13 ? undefined : /* Normal */0
    );
  var match$1 = zone.title;
  var match$2 = zone.displayOptions.showZoneTitle;
  var match$3 = zone.displayOptions.theme;
  var tmp;
  if (itemTemplate !== 12) {
    if (match$3 == null) {
      tmp = "Classic";
    } else {
      switch (match$3) {
        case "afp" :
            tmp = "Afp";
            break;
        case "info" :
            tmp = "Info";
            break;
        case "white" :
            tmp = "White";
            break;
        default:
          tmp = "Classic";
      }
    }
  } else {
    tmp = {
      NAME: "PlayNext",
      VAL: /* WithSwitch */0
    };
  }
  return {
          id: zone.id,
          link: makeLink(Caml_option.nullable_to_opt(zone.link)),
          title: !(match$1 == null) ? (
              match$2 ? ({
                    TAG: /* Displayed */0,
                    _0: match$1
                  }) : ({
                    TAG: /* Hidden */1,
                    _0: match$1
                  })
            ) : undefined,
          itemTitle: itemTitle,
          description: Caml_option.nullable_to_opt(zone.description),
          itemTemplate: itemTemplate,
          theme: tmp,
          data: Belt_Array.map(zone.data, Curry._1(toDsTeaser, itemTitle)),
          nextPage: Belt_Option.map(Caml_option.nullable_to_opt(zone.nextPage), (function (nextPage) {
                  return {
                          TAG: /* Emac */0,
                          _0: nextPage
                        };
                })),
          lastPage: undefined,
          totalPagesCount: undefined,
          slug: Caml_option.nullable_to_opt(zone.slug),
          code: Curry._1(Binding_Constant.Zone.DataKeys.decode, zone.code.name)
        };
}

function codeEmacV4ZoneToCode(code) {
  var match = Belt_Option.map(Belt_Option.map((code == null) ? undefined : Caml_option.some(code), (function (__x) {
              return __x.split("_");
            })), (function (param) {
          return Belt_Array.slice(param, 0, 2);
        }));
  var tmp;
  if (match !== undefined && match.length === 2) {
    var split1 = match[0];
    var split2 = match[1];
    tmp = "" + split1 + "_" + split2 + "";
  } else {
    tmp = "";
  }
  return Curry._1(Binding_Constant.Zone.DataKeys.decode, tmp);
}

function makeFromV4(toDsTeaser, zone) {
  var template = Curry._1(Binding_Constant.Zone.Template.tFromJs, zone.displayOptions.template);
  var match = zone.displayOptions.showItemTitle;
  var itemTitle = match ? (
      template === "horizontal-landscapeBigWithSubtitle" ? /* SubtitleAsTitle */1 : /* Normal */0
    ) : (
      template === "horizontal-portrait" ? /* Normal */0 : undefined
    );
  var match$1 = zone.title;
  var match$2 = zone.displayOptions.showZoneTitle;
  var match$3 = zone.displayOptions.theme;
  var tmp;
  var exit = 0;
  if (template === "tableview-playnext") {
    tmp = {
      NAME: "PlayNext",
      VAL: /* WithSwitch */0
    };
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (match$3 == null) {
      tmp = "Classic";
    } else {
      switch (match$3) {
        case "afp" :
            tmp = "Afp";
            break;
        case "info" :
            tmp = "Info";
            break;
        case "white" :
            tmp = "White";
            break;
        default:
          tmp = "Classic";
      }
    }
  }
  return {
          id: zone.id,
          link: makeLinkFromV4(Caml_option.nullable_to_opt(zone.link)),
          title: !(match$1 == null) ? (
              match$2 ? ({
                    TAG: /* Displayed */0,
                    _0: match$1
                  }) : ({
                    TAG: /* Hidden */1,
                    _0: match$1
                  })
            ) : undefined,
          itemTitle: itemTitle,
          description: Caml_option.nullable_to_opt(zone.description),
          itemTemplate: Belt_Option.mapWithDefault(template, /* Landscape */5, Binding_Constant.Zone.Template.toItemTemplate),
          theme: tmp,
          data: Belt_Array.map(zone.content.data, Curry._1(toDsTeaser, itemTitle)),
          nextPage: Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.nullable_to_opt(zone.content.pagination), (function (param) {
                          return Caml_option.nullable_to_opt(param.links);
                        })), (function (param) {
                      return Caml_option.nullable_to_opt(param.next);
                    })), (function (nextPage) {
                  return {
                          TAG: /* EmacV4 */2,
                          _0: nextPage
                        };
                })),
          lastPage: Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.nullable_to_opt(zone.content.pagination), (function (param) {
                          return Caml_option.nullable_to_opt(param.links);
                        })), (function (param) {
                      return Caml_option.nullable_to_opt(param.last);
                    })), (function (lastPage) {
                  return lastPage;
                })),
          totalPagesCount: Belt_Option.flatMap(Caml_option.nullable_to_opt(zone.content.pagination), (function (param) {
                  return Caml_option.nullable_to_opt(param.pages);
                })),
          slug: Caml_option.nullable_to_opt(zone.slug),
          code: codeEmacV4ZoneToCode(zone.code)
        };
}

function toDsZoneFromV4(toDsTeaser, category, pageParent, pageDescription, pageUrl, pageKind, zone) {
  var partial_arg = Curry._1(toDsTeaser, undefined);
  var getFirstTeaser = function (param) {
    return getFirstTeaserV4(partial_arg, param);
  };
  return Belt_Option.flatMap(Curry._1(Binding_Constant.Zone.Template.tFromJs, zone.displayOptions.template), (function (template) {
                if (template === "single-programContent") {
                  return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                return {
                                        NAME: "ProgramContent",
                                        VAL: [
                                          teaser,
                                          pageParent,
                                          /* Auto */0
                                        ]
                                      };
                              }));
                }
                if (template === "single-collectionContent") {
                  var trailerBehavior;
                  trailerBehavior = typeof pageKind === "number" || pageKind.TAG !== /* Rc */1 ? /* OnButtonClick */1 : pageKind._0;
                  return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                return {
                                        NAME: "ContentCollection",
                                        VAL: {
                                          teaser: teaser,
                                          description: pageDescription,
                                          pageParent: pageParent,
                                          favoriteButtonAvailability: "Available",
                                          primaryTitle: "h1",
                                          trailerBehavior: trailerBehavior
                                        }
                                      };
                              }));
                }
                if (template === "slider-landscape" || template === "slider-square" || template === "slider-banner") {
                  var match = zone.content.data;
                  if (match.length !== 1) {
                    var zone$1 = makeFromV4(toDsTeaser, zone);
                    return {
                            NAME: "TopTeaserWithCarousel",
                            VAL: [
                              zone$1,
                              pageKind,
                              category
                            ]
                          };
                  }
                  var teaser = match[0];
                  var dsTeaser = Curry._2(toDsTeaser, /* Normal */0, teaser);
                  var match$1 = dsTeaser.program.trailer;
                  var match$2 = dsTeaser.program.id;
                  if (match$1 !== undefined && match$2 !== undefined) {
                    return {
                            NAME: "TopTeaserWithTrailer",
                            VAL: [
                              dsTeaser,
                              pageKind,
                              match$2
                            ]
                          };
                  } else {
                    return {
                            NAME: "TopTeaser",
                            VAL: [
                              dsTeaser,
                              pageKind
                            ]
                          };
                  }
                }
                if (template === "horizontal-square" || template === "horizontal-landscapeBigWithSubtitle" || template === "horizontal-landscape-genre" || template === "horizontal-landscape" || template === "horizontalFirstHighlighted-square" || template === "horizontal-portrait" || template === "horizontal-landscapeBig" || template === "horizontal-poster") {
                  var match$3 = zone.content.data;
                  var match$4 = zone.authenticatedContent;
                  if (match$3.length !== 0 || !(match$4 == null)) {
                    return {
                            NAME: "Slider",
                            VAL: makeFromV4(toDsTeaser, zone)
                          };
                  } else {
                    return ;
                  }
                }
                if (template === "vertical-landscape" || template === "verticalFirstHighlighted-landscape") {
                  var zone$2 = makeFromV4(toDsTeaser, zone);
                  return {
                          NAME: "PaginatedGrid",
                          VAL: [
                            zone$2,
                            pageUrl
                          ]
                        };
                }
                if (template === "single-partner") {
                  return {
                          NAME: "Partner",
                          VAL: makeFromV4(toDsTeaser, zone)
                        };
                }
                if (template === "vertical-label") {
                  var dsZone = makeFromV4(toDsTeaser, zone);
                  var match$5 = dsZone.data;
                  if (match$5.length !== 0) {
                    return {
                            NAME: "Label",
                            VAL: dsZone
                          };
                  } else {
                    return ;
                  }
                }
                if (template === "single-pageHeader") {
                  return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                var match = teaser.program.clip;
                                if (match !== undefined) {
                                  return {
                                          NAME: "ContentCollectionClip",
                                          VAL: [
                                            teaser,
                                            pageParent,
                                            match
                                          ]
                                        };
                                }
                                var trailerBehavior;
                                trailerBehavior = typeof pageKind === "number" || pageKind.TAG !== /* Rc */1 ? /* OnButtonClick */1 : pageKind._0;
                                return {
                                        NAME: "ContentCollection",
                                        VAL: {
                                          teaser: teaser,
                                          description: pageDescription,
                                          pageParent: pageParent,
                                          favoriteButtonAvailability: "NotAvailable",
                                          primaryTitle: "h2",
                                          trailerBehavior: trailerBehavior
                                        }
                                      };
                              }));
                }
                if (template === "ebu-box") {
                  return {
                          NAME: "EbuBox",
                          VAL: [
                            Belt_Option.getWithDefault(Caml_option.nullable_to_opt(zone.title), ""),
                            Belt_Option.getWithDefault(Caml_option.nullable_to_opt(zone.description), ""),
                            zone.id
                          ]
                        };
                }
                if (template === "event-textOnRightSide") {
                  return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                var match = teaser.program.clip;
                                var match$1 = teaser.program.trailer;
                                var match$2 = teaser.program.id;
                                if (match !== undefined) {
                                  return {
                                          NAME: "EventZoneWithClip",
                                          VAL: [
                                            teaser,
                                            /* TextOnRightSide */1,
                                            match
                                          ]
                                        };
                                } else if (match$1 !== undefined && match$2 !== undefined) {
                                  return {
                                          NAME: "EventZoneWithTrailer",
                                          VAL: [
                                            teaser,
                                            /* TextOnRightSide */1,
                                            match$2
                                          ]
                                        };
                                } else {
                                  return {
                                          NAME: "EventZone",
                                          VAL: [
                                            teaser,
                                            /* TextOnRightSide */1
                                          ]
                                        };
                                }
                              }));
                }
                if (template !== "tableview-playnext") {
                  if (template === "single-newsletter") {
                    return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                  return {
                                          NAME: "Newsletter",
                                          VAL: teaser
                                        };
                                }));
                  } else if (template === "horizontalSelectedHighlighted-landscape") {
                    return ;
                  } else if (template === "tableview-guide") {
                    return {
                            NAME: "Guide",
                            VAL: makeFromV4(toDsTeaser, zone)
                          };
                  } else if (template === "single-banner") {
                    return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                  return {
                                          NAME: "Banner",
                                          VAL: teaser
                                        };
                                }));
                  } else {
                    return Belt_Option.map(Curry._1(getFirstTeaser, zone.content.data), (function (teaser) {
                                  var match = teaser.program.clip;
                                  var match$1 = teaser.program.trailer;
                                  var match$2 = teaser.program.id;
                                  if (match !== undefined) {
                                    return {
                                            NAME: "EventZoneWithClip",
                                            VAL: [
                                              teaser,
                                              /* TextOnLeftSide */0,
                                              match
                                            ]
                                          };
                                  } else if (match$1 !== undefined && match$2 !== undefined) {
                                    return {
                                            NAME: "EventZoneWithTrailer",
                                            VAL: [
                                              teaser,
                                              /* TextOnLeftSide */0,
                                              match$2
                                            ]
                                          };
                                  } else {
                                    return {
                                            NAME: "EventZone",
                                            VAL: [
                                              teaser,
                                              /* TextOnLeftSide */0
                                            ]
                                          };
                                  }
                                }));
                  }
                }
                var zone$3 = makeFromV4(toDsTeaser, zone);
                var match$6 = zone$3.data;
                var len = match$6.length;
                if (len !== 1) {
                  if (len !== 0) {
                    return {
                            NAME: "PlayNextSlider",
                            VAL: zone$3
                          };
                  } else {
                    return ;
                  }
                }
                var firstData = match$6[0];
                return {
                        NAME: "PlayNextTeaser",
                        VAL: [
                          firstData,
                          zone$3.title
                        ]
                      };
              }));
}

function toDsZone(toDsTeaser, category, pageParent, pageDescription, pageUrl, pageKind, zone) {
  var partial_arg = Curry._1(toDsTeaser, undefined);
  var getFirstTeaser$1 = function (param) {
    return getFirstTeaser(partial_arg, param);
  };
  var match = Curry._1(Binding_Constant.Zone.Item_Template.decode, zone.displayOptions.itemTemplate);
  var match$1 = Curry._1(Binding_Constant.Zone.Layout.decode, zone.displayOptions.zoneLayout);
  var exit = 0;
  var exit$1 = 0;
  switch (match) {
    case /* Banner */0 :
        switch (match$1) {
          case /* Single */4 :
              return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                            return {
                                    NAME: "Banner",
                                    VAL: teaser
                                  };
                          }));
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* ContentCollection */1 :
        switch (match$1) {
          case /* Single */4 :
              return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                            var trailerBehavior;
                            trailerBehavior = typeof pageKind === "number" || pageKind.TAG !== /* Rc */1 ? /* OnButtonClick */1 : pageKind._0;
                            return {
                                    NAME: "ContentCollection",
                                    VAL: {
                                      teaser: teaser,
                                      description: pageDescription,
                                      pageParent: pageParent,
                                      favoriteButtonAvailability: "NotAvailable",
                                      primaryTitle: "h2",
                                      trailerBehavior: trailerBehavior
                                    }
                                  };
                          }));
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* EbuBox */2 :
        return {
                NAME: "EbuBox",
                VAL: [
                  Belt_Option.getWithDefault(Caml_option.nullable_to_opt(zone.title), ""),
                  Belt_Option.getWithDefault(Caml_option.nullable_to_opt(zone.description), ""),
                  zone.id
                ]
              };
    case /* Guide */3 :
        switch (match$1) {
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* TableView */6 :
              return {
                      NAME: "Guide",
                      VAL: make(toDsTeaser, zone)
                    };
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* Single */4 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* Label */4 :
        switch (match$1) {
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* Single */4 :
          case /* TableView */6 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          case /* Vertical */7 :
              var dsZone = make(toDsTeaser, zone);
              var match$2 = dsZone.data;
              if (match$2.length !== 0) {
                return {
                        NAME: "Label",
                        VAL: dsZone
                      };
              } else {
                return ;
              }
          
        }
        break;
    case /* Landscape */5 :
        switch (match$1) {
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* Single */4 :
          case /* TableView */6 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          case /* PaginatedList */3 :
          case /* Vertical */7 :
              exit = 1;
              break;
          
        }
        break;
    case /* Newsletter */9 :
        switch (match$1) {
          case /* Single */4 :
              return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                            return {
                                    NAME: "Newsletter",
                                    VAL: teaser
                                  };
                          }));
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* PageHeader */10 :
        switch (match$1) {
          case /* Single */4 :
              return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                            var clip = teaser.program.clip;
                            if (clip !== undefined) {
                              return {
                                      NAME: "ContentCollectionClip",
                                      VAL: [
                                        teaser,
                                        pageParent,
                                        clip
                                      ]
                                    };
                            }
                            var trailerBehavior;
                            trailerBehavior = typeof pageKind === "number" || pageKind.TAG !== /* Rc */1 ? /* OnButtonClick */1 : pageKind._0;
                            return {
                                    NAME: "ContentCollection",
                                    VAL: {
                                      teaser: teaser,
                                      description: pageDescription,
                                      pageParent: pageParent,
                                      favoriteButtonAvailability: "NotAvailable",
                                      primaryTitle: "h2",
                                      trailerBehavior: trailerBehavior
                                    }
                                  };
                          }));
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* Partner */11 :
        switch (match$1) {
          case /* Single */4 :
              return {
                      NAME: "Partner",
                      VAL: make(toDsTeaser, zone)
                    };
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* PlayNext */12 :
        switch (match$1) {
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* TableView */6 :
              var dsZone$1 = make(toDsTeaser, zone);
              var match$3 = dsZone$1.data;
              var len = match$3.length;
              if (len !== 1) {
                if (len !== 0) {
                  return {
                          NAME: "PlayNextSlider",
                          VAL: dsZone$1
                        };
                } else {
                  return ;
                }
              }
              var firstData = match$3[0];
              return {
                      NAME: "PlayNextTeaser",
                      VAL: [
                        firstData,
                        dsZone$1.title
                      ]
                    };
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* Single */4 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* ProgramContent */15 :
        switch (match$1) {
          case /* Single */4 :
              return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                            return {
                                    NAME: "ProgramContent",
                                    VAL: [
                                      teaser,
                                      pageParent,
                                      /* Auto */0
                                    ]
                                  };
                          }));
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* Horizontal_First_Highlited */2 :
          case /* PaginatedList */3 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* Square */16 :
        switch (match$1) {
          case /* Horizontal_First_Highlited */2 :
              exit = 2;
              break;
          case /* Horizontal */1 :
          case /* Slider */5 :
              exit$1 = 3;
              break;
          case /* Event */0 :
          case /* PaginatedList */3 :
          case /* Single */4 :
          case /* TableView */6 :
          case /* Vertical */7 :
              Util_Logger.error2("This zone is unkown", zone);
              return ;
          
        }
        break;
    case /* LandscapeBig */6 :
    case /* LandscapeBigWithSubtitle */7 :
    case /* LandscapeGenre */8 :
    case /* Portrait */13 :
    case /* Poster */14 :
    case /* TextOnLeftSide */17 :
    case /* TextOnRightSide */18 :
        exit$1 = 3;
        break;
    
  }
  if (exit$1 === 3) {
    if (match$1 !== 1) {
      if (match$1 !== 5) {
        if (match >= 17) {
          if (match$1 !== 0) {
            Util_Logger.error2("This zone is unkown", zone);
            return ;
          }
          var textAlignment = match !== 17 && match >= 18 ? /* TextOnRightSide */1 : /* TextOnLeftSide */0;
          return Belt_Option.map(Curry._1(getFirstTeaser$1, zone.data), (function (teaser) {
                        var match = teaser.program.clip;
                        var match$1 = teaser.program.trailer;
                        var match$2 = teaser.program.id;
                        if (match !== undefined) {
                          return {
                                  NAME: "EventZoneWithClip",
                                  VAL: [
                                    teaser,
                                    textAlignment,
                                    match
                                  ]
                                };
                        } else if (match$1 !== undefined && match$2 !== undefined) {
                          return {
                                  NAME: "EventZoneWithTrailer",
                                  VAL: [
                                    teaser,
                                    textAlignment,
                                    match$2
                                  ]
                                };
                        } else {
                          return {
                                  NAME: "EventZone",
                                  VAL: [
                                    teaser,
                                    textAlignment
                                  ]
                                };
                        }
                      }));
        }
        Util_Logger.error2("This zone is unkown", zone);
        return ;
      }
      var match$4 = zone.data;
      if (match$4.length !== 1) {
        var zone$1 = make(toDsTeaser, zone);
        return {
                NAME: "TopTeaserWithCarousel",
                VAL: [
                  zone$1,
                  pageKind,
                  category
                ]
              };
      }
      var teaser = match$4[0];
      var dsTeaser = Curry._2(toDsTeaser, /* Normal */0, teaser);
      var match$5 = dsTeaser.program.trailer;
      var match$6 = dsTeaser.program.id;
      if (match$5 !== undefined && match$6 !== undefined) {
        return {
                NAME: "TopTeaserWithTrailer",
                VAL: [
                  dsTeaser,
                  pageKind,
                  match$6
                ]
              };
      } else {
        return {
                NAME: "TopTeaser",
                VAL: [
                  dsTeaser,
                  pageKind
                ]
              };
      }
    }
    exit = 2;
  }
  switch (exit) {
    case 1 :
        var zone$2 = make(toDsTeaser, zone);
        return {
                NAME: "PaginatedGrid",
                VAL: [
                  zone$2,
                  pageUrl
                ]
              };
    case 2 :
        var match$7 = zone.data;
        var match$8 = zone.authenticatedContent;
        if (match$7.length !== 0 || !(match$8 == null)) {
          return {
                  NAME: "Slider",
                  VAL: make(toDsTeaser, zone)
                };
        } else {
          return ;
        }
    
  }
}

var withBackgroundSpacer = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.Zone.Slider.withBackgroundDesktop), undefined, undefined, Particle_Spacer_Constants.Zone.Slider.withBackgroundMobile);

var afterTopTeaserSpacer = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.Zone.Slider.afterTopTeaserDesktop), undefined, undefined, Particle_Spacer_Constants.Zone.Slider.afterTopTeaserMobile);

var topContentSpacer = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.allZero), undefined, undefined, Particle_Spacer_Constants.allZero);

var firstContent = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.Zone.firstDesktop), undefined, undefined, Particle_Spacer_Constants.Zone.firstMobile);

var defaultSpacer = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Constants.Zone.desktop), undefined, undefined, Particle_Spacer_Constants.Zone.mobile);

function getSpacers(previousZone, zone) {
  if (typeof zone === "object" && zone.NAME === "Slider") {
    var match = zone.VAL.theme;
    if (match === "White") {
      return withBackgroundSpacer;
    }
    if (match === "Info" || match === "Afp") {
      return withBackgroundSpacer;
    }
    
  }
  if (previousZone !== undefined) {
    if (typeof previousZone !== "object") {
      return defaultSpacer;
    }
    var variant = previousZone.NAME;
    if (variant === "TopTeaser" || variant === "TopTeaserWithTrailer" || variant === "TopTeaserWithCarousel") {
      return afterTopTeaserSpacer;
    } else {
      return defaultSpacer;
    }
  }
  if (typeof zone !== "object") {
    return firstContent;
  }
  var variant$1 = zone.NAME;
  if (variant$1 === "TopTeaser" || variant$1 === "ContentCollection" || variant$1 === "TopTeaserWithTrailer" || variant$1 === "TopTeaserWithCarousel" || variant$1 === "ContentCollectionClip") {
    return topContentSpacer;
  } else {
    return firstContent;
  }
}

function transformZones(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, category, pageParent, pageDescription, pageUrl, pageKind, zones) {
  var arg = pageKind;
  var toDsTeaser = function (param, param$1, param$2) {
    return function (param$3, param$4) {
      return Emac_Teaser.toDsTeaser(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, param, param$1, param$2, arg, param$3, param$4);
    };
  };
  var makeZone = function (param) {
    return function (param$1) {
      return toDsZone(param, category, pageParent, pageDescription, pageUrl, pageKind, param$1);
    };
  };
  return Belt_Array.reduce(zones, {
              previousTemplate: undefined,
              result: []
            }, (function (param, currentZone) {
                var result = param.result;
                var previousTemplate = param.previousTemplate;
                var zoneId = currentZone.id;
                var key = currentZone.id;
                var itemTemplate = Curry._1(Binding_Constant.Zone.Item_Template.decode, currentZone.displayOptions.itemTemplate);
                var newT = Belt_Option.flatMap(makeZone(function (itemTitle, teaser) {
                            return toDsTeaser(zoneId, itemTitle, itemTemplate)(undefined, teaser);
                          })(currentZone), (function (template) {
                        var variant = template.NAME;
                        if (variant === "Partner" || variant === "PlayNextSlider" || variant === "ProgramContent" || variant === "PlayNextTeaser" || variant === "Label") {
                          return {
                                  TAG: /* Program */1,
                                  _0: {
                                    template: template
                                  }
                                };
                        } else if (variant === "Guide") {
                          return {
                                  TAG: /* Guide */2,
                                  _0: template
                                };
                        } else {
                          return {
                                  TAG: /* Main */0,
                                  _0: {
                                    id: zoneId,
                                    template: template,
                                    key: key,
                                    blockSpace: getSpacers(previousTemplate, template),
                                    method: Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.nullable_to_opt(currentZone.authenticatedContent), (function (param) {
                                                        return Caml_option.nullable_to_opt(param.contentId);
                                                      })), Emac_Zone.contentIdFromJs), (function (contentId) {
                                                return /* Connected */{
                                                        _0: contentId
                                                      };
                                              })), /* Static */0)
                                  }
                                };
                        }
                      }));
                if (newT === undefined) {
                  return {
                          previousTemplate: previousTemplate,
                          result: result
                        };
                }
                switch (newT.TAG | 0) {
                  case /* Main */0 :
                      result.push(newT);
                      return {
                              previousTemplate: newT._0.template,
                              result: result
                            };
                  case /* Program */1 :
                  case /* Guide */2 :
                      result.push(newT);
                      return {
                              previousTemplate: previousTemplate,
                              result: result
                            };
                  
                }
              })).result;
}

function transformZonesV4(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, category, pageParent, pageDescription, pageUrl, pageKind, zones) {
  var arg = pageKind;
  var toDsTeaser = function (param, param$1, param$2) {
    return function (param$3) {
      return Emac_V4_Teaser.toDsTeaser(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, param, param$1, param$2, arg, param$3);
    };
  };
  var makeZone = function (param) {
    return function (param$1) {
      return toDsZoneFromV4(param, category, pageParent, pageDescription, pageUrl, pageKind, param$1);
    };
  };
  return Belt_Array.reduce(zones, {
              previousTemplate: undefined,
              result: []
            }, (function (param, currentZone) {
                var result = param.result;
                var previousTemplate = param.previousTemplate;
                var template = Curry._1(Binding_Constant.Zone.Template.tFromJs, currentZone.displayOptions.template);
                var zoneId = currentZone.id;
                var key = currentZone.id;
                var newT = Belt_Option.flatMap(makeZone(function (itemTitle, teaser) {
                            return toDsTeaser(template, zoneId, itemTitle)(teaser);
                          })(currentZone), (function (template) {
                        var variant = template.NAME;
                        if (variant === "Partner" || variant === "PlayNextSlider" || variant === "ProgramContent" || variant === "PlayNextTeaser" || variant === "Label") {
                          return {
                                  TAG: /* Program */1,
                                  _0: {
                                    template: template
                                  }
                                };
                        } else if (variant === "Guide") {
                          return {
                                  TAG: /* Guide */2,
                                  _0: template
                                };
                        } else {
                          return {
                                  TAG: /* Main */0,
                                  _0: {
                                    id: zoneId,
                                    template: template,
                                    key: key,
                                    blockSpace: getSpacers(previousTemplate, template),
                                    method: Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.nullable_to_opt(currentZone.authenticatedContent), (function (param) {
                                                        return Caml_option.nullable_to_opt(param.contentId);
                                                      })), Emac_Zone.contentIdFromJs), (function (contentId) {
                                                return /* Connected */{
                                                        _0: contentId
                                                      };
                                              })), /* Static */0)
                                  }
                                };
                        }
                      }));
                if (newT === undefined) {
                  return {
                          previousTemplate: previousTemplate,
                          result: result
                        };
                }
                switch (newT.TAG | 0) {
                  case /* Main */0 :
                      result.push(newT);
                      return {
                              previousTemplate: newT._0.template,
                              result: result
                            };
                  case /* Program */1 :
                  case /* Guide */2 :
                      result.push(newT);
                      return {
                              previousTemplate: previousTemplate,
                              result: result
                            };
                  
                }
              })).result;
}

function makeFromClub(minutesLabel, initialZone, kind, page, nextPage) {
  return {
          id: initialZone.id,
          link: initialZone.link,
          title: initialZone.title,
          itemTitle: initialZone.itemTitle,
          description: initialZone.description,
          itemTemplate: initialZone.itemTemplate,
          theme: initialZone.theme,
          data: nextPage.map(function (param) {
                return Type_Club.Teaser.toDsTeaser(minutesLabel, param);
              }),
          nextPage: {
            TAG: /* Club */1,
            _0: kind,
            _1: page
          },
          lastPage: initialZone.lastPage,
          totalPagesCount: initialZone.totalPagesCount,
          slug: initialZone.slug,
          code: initialZone.code
        };
}

function makeFromNextZone(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, initialZone, nextPage) {
  return {
          id: initialZone.id,
          link: initialZone.link,
          title: initialZone.title,
          itemTitle: initialZone.itemTitle,
          description: initialZone.description,
          itemTemplate: initialZone.itemTemplate,
          theme: initialZone.theme,
          data: Belt_Array.map(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(nextPage.data), []), (function (__x) {
                  return Emac_Teaser.toDsTeaser(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, Curry._1(Type_String.Zone.Id.make, initialZone.id), /* Normal */0, initialZone.itemTemplate, undefined, undefined, __x);
                })),
          nextPage: Belt_Option.map(Caml_option.nullable_to_opt(nextPage.nextPage), (function (nextPage) {
                  return {
                          TAG: /* Emac */0,
                          _0: nextPage
                        };
                })),
          lastPage: initialZone.lastPage,
          totalPagesCount: initialZone.totalPagesCount,
          slug: initialZone.slug,
          code: initialZone.code
        };
}

function makeFromV4NextZone(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, initialZone, nextPage) {
  return {
          id: initialZone.id,
          link: initialZone.link,
          title: initialZone.title,
          itemTitle: initialZone.itemTitle,
          description: initialZone.description,
          itemTemplate: initialZone.itemTemplate,
          theme: initialZone.theme,
          data: Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(nextPage.data), (function (__x) {
                      return Belt_Array.map(__x, (function (__x) {
                                    return Emac_V4_Teaser.toDsTeaser(dateFormater, betweenDatesFormater, nextBroadcastDateFormater, timeReference, undefined, Curry._1(Type_String.Zone.Id.make, initialZone.id), /* Normal */0, undefined, __x);
                                  }));
                    })), []),
          nextPage: Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Caml_option.nullable_to_opt(nextPage.pagination), (function (param) {
                          return Caml_option.nullable_to_opt(param.links);
                        })), (function (param) {
                      return Caml_option.nullable_to_opt(param.next);
                    })), (function (nextPage) {
                  return {
                          TAG: /* EmacV4 */2,
                          _0: nextPage
                        };
                })),
          lastPage: initialZone.lastPage,
          totalPagesCount: initialZone.totalPagesCount,
          slug: initialZone.slug,
          code: initialZone.code
        };
}

exports.canBeDisplayed = canBeDisplayed;
exports.getFirstTeaser = getFirstTeaser;
exports.getFirstTeaserV4 = getFirstTeaserV4;
exports.makeLink = makeLink;
exports.makeLinkFromV4 = makeLinkFromV4;
exports.make = make;
exports.codeEmacV4ZoneToCode = codeEmacV4ZoneToCode;
exports.makeFromV4 = makeFromV4;
exports.toDsZoneFromV4 = toDsZoneFromV4;
exports.toDsZone = toDsZone;
exports.withBackgroundSpacer = withBackgroundSpacer;
exports.afterTopTeaserSpacer = afterTopTeaserSpacer;
exports.topContentSpacer = topContentSpacer;
exports.firstContent = firstContent;
exports.defaultSpacer = defaultSpacer;
exports.getSpacers = getSpacers;
exports.transformZones = transformZones;
exports.transformZonesV4 = transformZonesV4;
exports.makeFromClub = makeFromClub;
exports.makeFromNextZone = makeFromNextZone;
exports.makeFromV4NextZone = makeFromV4NextZone;
/* withBackgroundSpacer Not a pure module */
